import jwt_decode from "jwt-decode";
import { VALIDATIONS } from "./config";

const saveDeviceId = (deviceId) => {
  localStorage.setItem("nvDeviceId", deviceId);
};

const setCookie = (value, cookieName) => {
  document.cookie = `${cookieName}=${value}; expires=${new Date(
    new Date().getTime() + 365 * 24 * 60 * 60 * 1000
  ).toUTCString()}; domain=${LOGIN_HINTS_COOKIE_DOMAIN}; path=/; secure`;
};

export const getDeviceId = () => {
  let deviceId = localStorage.getItem("nvDeviceId");
  if (deviceId) {
    return deviceId;
  }
  let d = Date.now();

  deviceId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      const r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    }
  );
  saveDeviceId(deviceId);
  return deviceId;
};

export const saveSessionInfo = (searchParams, passedState) => {
  let expirationDate = new Date();
  expirationDate = new Date(
    expirationDate.getTime() + searchParams.get("expires_in") * 1000
  );
  let idToken = searchParams.get("id_token");
  let refreshToken = searchParams.get("refresh_token");
  const decodedToken = jwt_decode(idToken);
  const sessionInfo = {
    access_token: searchParams.get("access_token"),
    idp_id: decodedToken?.idp_id,
    id_token: idToken,
    expiration: expirationDate,
    email: decodedToken?.email,
    client_id: passedState.client_id,
    ...(refreshToken && { refresh_token: refreshToken }),
  };
  localStorage.setItem(
    CLIENT_ID_MAPPING[passedState.client_id],
    JSON.stringify(sessionInfo)
  );
  localStorage.setItem(
    LAST_LOGIN_ITEM_NAME,
    CLIENT_ID_MAPPING[passedState.client_id]
  );
  const serializedHints = JSON.stringify({
    login_hint: decodedToken?.email,
    idp_id: decodedToken?.idp_id,
    timestamp: new Date().toISOString(),
    sub: decodedToken?.sub,
  });
  localStorage.setItem(LOGIN_HINTS_ITEM_NAME, serializedHints);
  setCookie(serializedHints, LOGIN_HINTS_ITEM_NAME);
};

export const getNonce = (length) => {
  let nonce = "";
  const allowed =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (let i = 0; i < length; i++) {
    nonce = nonce.concat(
      allowed.charAt(Math.floor(Math.random() * allowed.length))
    );
  }
  return btoa(nonce);
};

export const generateCodeChallenge = async () => {
  // Generate a 32-octet random sequence
  const rand = window.crypto.getRandomValues(new Uint8Array(32));

  // The PKCE code verifier is the base64url encoding of the random octets
  const codeVerifier = b64url(rand);
  sessionStorage.setItem("CV", codeVerifier);

  // Calculate the SHA-256 hash of the code verifier
  const data = new TextEncoder().encode(codeVerifier);
  const sha256 = await window.crypto.subtle.digest("SHA-256", data);
  console.log(sha256);
  // The PKCE code challenge is the base64url encoding of the hash
  return b64url(new Uint8Array(sha256));
};

function b64url(array) {
  const b64 = btoa(String.fromCharCode.apply(null, array));
  return b64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}

export const redirect = (url) => {
  if (
    url?.includes("javascript:") ||
    url?.includes("vbscript:")
  ) {
    return;
  }
  if (url && url.match(VALIDATIONS.urlRegex)) {
    location.href = url;
  }
};
